const STORAGE_KEY = 'ui_embed';

function normalizeQueryValue(value) {
    if (value === undefined || value === null) {
        return '';
    }
    if (Array.isArray(value)) {
        return String(value[0] || '').trim().toLowerCase();
    }
    return String(value).trim().toLowerCase();
}

/**
 * 落地页 / 深链 query 是否表示嵌入模式（对方 App WebView）
 */
export function isEmbedQuery(query) {
    const q = query || {};
    const embed = normalizeQueryValue(q.embed);
    if (embed === '1' || embed === 'true' || embed === 'yes') {
        return true;
    }
    const from = normalizeQueryValue(q.from);
    if (from === 'tappo') {
        return true;
    }
    return false;
}

export function readEmbedMode() {
    try {
        return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

export function writeEmbedMode() {
    try {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
        return true;
    } catch (e) {
        return false;
    }
}

export function clearEmbedMode() {
    try {
        window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        /* ignore */
    }
}

/**
 * 若 query 为嵌入模式则写入 sessionStorage，返回是否为嵌入
 */
export function applyEmbedFromQuery(query) {
    if (!isEmbedQuery(query)) {
        return readEmbedMode();
    }
    writeEmbedMode();
    return true;
}
